module.exports = __webpack_public_path__ + "static/media/learning-18.496ed8dc.png";